import { MenuItem, Select } from "@mui/material";

import { Resources, useResource } from "Infrastructure/Translations/Resources";

export type ReportingPeriod =
  | "ThisMonth"
  | "Last30Days"
  | "ThisYear"
  | "LastYear"
  | null;

type Props = {
  value: ReportingPeriod;
  onChange: (period: ReportingPeriod) => void;
};

const PERIODS = [
  { value: "all", labelKey: Resources.Reporting.PeriodAll },
  { value: "ThisMonth", labelKey: Resources.Reporting.PeriodThisMonth },
  { value: "Last30Days", labelKey: Resources.Reporting.PeriodLast30Days },
  { value: "ThisYear", labelKey: Resources.Reporting.PeriodThisYear },
  { value: "LastYear", labelKey: Resources.Reporting.PeriodLastYear },
] as const;

export const PeriodSelector = ({ value, onChange }: Props): React.ReactNode => {
  const { t } = useResource();

  return (
    <Select
      value={value ?? "all"}
      onChange={(e) => {
        const v = e.target.value;
        onChange(v === "all" ? null : (v as ReportingPeriod));
      }}
      size="small"
      variant="standard"
      disableUnderline
      sx={{
        minWidth: 140,
        fontSize: 13,
        color: "text.secondary",
        bgcolor: "transparent",
        "& .MuiSelect-select": {
          py: 0.5,
          pr: "24px !important",
        },
        "& .MuiSelect-icon": {
          color: "text.secondary",
        },
      }}
    >
      {PERIODS.map((period) => (
        <MenuItem key={period.value} value={period.value} sx={{ fontSize: 13 }}>
          {t(period.labelKey)}
        </MenuItem>
      ))}
    </Select>
  );
};
